<div class="container-fluid py-5">
  <div class="row justify-content-center">
    <div
      class="col-4 col-md-2"
      *ngFor="let card of resumenCardsTwo; index as i"
    >
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 0 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
              >
                <!-- {{ card.value }} -->
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 0 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
              >
                <!-- {{ card.value }} -->
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card-tools">
    <div class="row text-center">
      <div class="col-12">
        <a [routerLink]="['/numbers']" class="btn btn-dark btn-sm btn-redirect">
          Stripe
        </a>
        <a
          [routerLink]="['/numbers/finance/square']"
          class="btn btn-dark btn-sm btn-redirect"
        >
          Square
        </a>
        <a
          [routerLink]="['/numbers/finance/paypal']"
          class="btn btn-dark btn-sm btn-select"
        >
          Paypal
        </a>
      </div>
    </div>
  </div>
  <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <a class="btn btn-dark btn-sm btn-refresh" (click)="getData()">
        <i class="fa-solid fa-arrow-rotate-right"></i>
      </a>
      <div class="flex-grow-1 text-center">
        <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(1)">
          Balances
        </a>
        <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(2)">
          Transactions
        </a>
        <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(3)">
          Disputes
        </a>
        <a class="btn btn-dark btn-sm btn-step" (click)="changeStep(4)">
          Payouts
        </a>
      </div>
      <div style="width: 40px"></div>
    </div>
  </div>

  <br />

  <!-- Balances -->
  <h2 *ngIf="step == 1">Balances</h2>

  <div class="card shadow-sm" *ngIf="step == 1">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of balances">
              <td>
                {{ item.total_balance.currency_code }}
                <!-- {{ item.total_balance.value / 100 | number : "1.2-2" }} -->
                {{ item.total_balance.value }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Transations -->
  <h2 *ngIf="step == 2">Transations</h2>

  <div class="card shadow-sm" *ngIf="step == 2">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Date</th>
              <th>Name</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of transactions">
              <td>
                <!-- {{
                  item.transaction_info.transaction_initiation_date * 1000
                    | date : "dd/MM/yyyy HH:mm:ss"
                }} -->
                {{
                  item.transaction_info.transaction_initiation_date
                    | date: "dd/MM/yyyy HH:mm:ss"
                }}
              </td>
              <td>
                {{ item.payer_info.payer_name.alternate_full_name }}
              </td>
              <td>
                {{ item.transaction_info.transaction_amount.currency_code }}
                {{ item.transaction_info.transaction_amount.value }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Disputes -->
  <h2 *ngIf="step == 3">Disputes</h2>

  <div class="card shadow-sm" *ngIf="step == 3">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <!-- <thead>
            <tr>
              <th>Item</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of disputes">
              <td>
                {{ item.items.currency_code }}
                 {{ item.items.value }}
              </td>
            </tr>
          </tbody> -->
        </table>
      </div>
    </div>
  </div>

  <!-- Payouts -->
  <h2 *ngIf="step == 4">Payouts</h2>

  <div class="card shadow-sm" *ngIf="step == 4">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Amount</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of payouts">
              <td>
                {{ item.currency }}
                {{ item.amount }}
              </td>
              <!-- {{ item.amount / 100 | number : "1.2-2" }} -->
              <td>{{ item.date | date: "dd/MM/yyyy HH:mm:ss" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
